import React from 'react';
import clsx from 'clsx';
import Dropdown from './Dropdown';

export function SortCriteria({ sortCriteria, className, ...props }) {
    if (!sortCriteria?.length) {
        return null;
    }
    
    const selectedOption = sortCriteria.find(x => x.selected === true) ?? sortCriteria[0];
    
    return (
        <Dropdown {...props}
                  label={selectedOption.text}
                  className={clsx("facet-filter-dropdown", className)}>
            {sortCriteria.map((item, idx) => (
                <Dropdown.Item key={`sortCriteriaCompact-${idx}`}>
                    <a href={item.value}
                       rel="noreferrer noopener"
                       title={item.text}
                       aria-label={item.text}
                       className="">
                        {item.text}
                    </a>
                </Dropdown.Item>
            ))}
        </Dropdown>
    );
}

export default SortCriteria;
